<template>
  <div class="row m-0">
    <div class="cutting col" :id="'cutting_' + index" :style="{width: width + 'px', height: height + 'px'}"></div>
    <div class="col">
      <table class="table table-sm table-bordered">
        <tr v-for="(values, key, index) in info" :key="index">
          <td v-if="index == 0">
            <b>{{ key }}</b>
          </td>
          <td v-if="index > 0">{{ key }}</td>
          <td v-for="(value, index) in values" :key="index">{{ parseFloat(value) ? Number(parseFloat(value).toFixed(1)) : value }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Konva from 'konva';

export default {
  name: "Part",
  props: {
    index: Number,
    width: Number,
    height: Number,
    group: Object,
    info: Object,
  },
  data() {
    return {
      stage: Object,
    }
  },
  methods: {
    init() {
      this.stage = new Konva.Stage({
        container: 'cutting_' + this.index,
        width: this.width,
        height: this.height,
      });
      
      this.updateMesh();
    },
    updateMesh() {
      this.stage.destroyChildren();
      var layer = new Konva.Layer();

      layer.add(this.group);
      this.stage.add(layer);

      layer.draw();
    },
  },
  mounted() {
    this.init();
  },
}
</script>
